export const DIETARY_PREFERENCES_MAP = {
  gourmet: 'No dietary preference',
  vegetarian: 'Vegetarian',
}
